import { useTranslation } from "react-i18next";
import { useCompanyInfo } from "../../hooks/useCompanyInfo";

const CompanyLogo = ({ showCompanyName = true }) => {
  const { t } = useTranslation();
  const companyInfo = useCompanyInfo();
  const companyName = companyInfo?.company?.trade_name || companyInfo?.company?.legal_name;
  const companyLogo = companyInfo?.company?.logo_url;
  const companyLoading = companyInfo?.loading;

  const logoSrc = companyLogo
    ? companyLogo.startsWith("/uploads/")
      ? `${process.env.REACT_APP_API_URL || "/api"}${companyLogo}`
      : companyLogo
    : null;

  return (
    <div className="flex items-center gap-2.5">
      {logoSrc ? (
        <img src={logoSrc} alt={`Logo ${companyName}`}
          className="w-8 h-8 object-contain rounded-lg"
          onError={e => (e.target.style.display = "none")} />
      ) : (
        <img src="/assets/brand/mawered-navbar-lockup.svg" alt="Mawered"
          style={{ height: "20px", width: "auto" }} />
      )}
      {showCompanyName && (
        <div>
          <p className="text-xs" style={{ color: "var(--lm-ink-3)" }}>
            {companyLoading ? t('common.loading') : companyName}
          </p>
        </div>
      )}
    </div>
  );
};

export default CompanyLogo;
